export const RouteStatusEnum = Object.freeze({
    errorApi: "errorApi",
    errorPoi: "errorPoi",
    none: 'none',
    loading: "loading",
    ok: "ok",
    errorVehicle: 'errorVehicle'
})